const welcome = {
  PersonalInformation: {
    Header: "Confirm your personal information",
    Description:
      "Your account information will be used for both Fullscript and Emerson Ecologics. Please confirm that the information below is correct.",
    FirstName: "First name",
    LastName: "Last name",
    Title: "Title",
    Suffix: "Suffix",
    FirstNameRequired: "First name is required",
    LastNameRequired: "Last name is required",
  },
};

export { welcome };
